import { Form as FormikForm, FormikProps } from 'formik';
import React, { useState } from 'react';

import { css } from '@emotion/core';
import { mq } from '@helpers/breakpoints';
import { Button, Text } from '@rebass/emotion';
import Colors from '@theme/colors';

interface TrialLandingPageValues {
  email: string;
}

interface FormProps {
  strings: any;
}

const MobileSignup = ({
  handleChange,
  handleBlur,
  values,
  errors,
  strings,
}: FormikProps<TrialLandingPageValues> & FormProps) => {
  const [privacyOpened, togglePrivacy] = useState(false);
  const {
    right: { privacyLink, privacyText, privacyURL, signUp, enterEmail },
  } = strings;

  return (
    <div
      css={mq({
        height: '2.8rem',
        display: ['block', 'block', 'none'],
        position: 'fixed',
        width: '100%',
        bottom: !privacyOpened ? '0px' : '4.2em',
        zIndex: 1,
      })}
      data-c="mobile-signup"
    >
      <FormikForm
        css={css`
          position: relative;
          display: flex;
        `}
      >
        {errors.email && (
          <Text
            css={css`
              position: absolute;
              top: -20px;
              color: ${Colors.errorMsg};
            `}
          >
            {errors.email}
          </Text>
        )}
        <input
          type="email"
          name="email"
          placeholder={enterEmail}
          onFocus={() => togglePrivacy(true)}
          css={css`
            width: 70%;
            border: 1px solid ${Colors.grayLight9};
            background-color: ${Colors.neutral0};
            font-size: 1em;
            padding-left: 4%;
            border-radius: 0;
            margin: 0;
            ::placeholder {
              font-size: 1rem;
              padding-left: 10px;
            }
          `}
          autoComplete="off"
          onChange={handleChange}
          onBlur={(e) => {
            handleBlur(e);
            setTimeout(() => {
              togglePrivacy(false);
            }, 500);
          }}
          value={values.email}
          data-i="mobile-signup-input"
        />
        <Button
          bg={Colors.neutral75}
          css={css`
            border-radius: 0 2px 2px 0;
            height: 100%;
            padding-top: 6px;
            height: 46px;
            width: 30%;
            &:hover {
              cursor: pointer;
            }
          `}
          type="submit"
          dataI="mobile-signup-button"
        >
          <Text fontSize={['14px']} lineHeight={1.5} color={Colors.neutral0}>
            {signUp}
          </Text>
        </Button>
      </FormikForm>
      <Text
        css={css`
          padding: 2% 4% 5% 4%;
          font-size: 0.9em;
          background-color: ${Colors.neutral0};
          height: 100px;
        `}
      >
        {privacyText}
        <a
          href={privacyURL}
          target="_blank"
          rel="noopener"
          css={css`
            color: ${Colors.science37};
            text-decoration: none;
            margin-left: 4px;
          `}
        >
          {privacyLink}
        </a>
        .
      </Text>
    </div>
  );
};

export default MobileSignup;
